// extracted by mini-css-extract-plugin
module.exports = {"faqQuestionBox":"FAQPage_faqQuestionBox__6Z_mt","faqQuestion":"FAQPage_faqQuestion__UM73_","faqAnswer":"FAQPage_faqAnswer__43VPx"};